@if (this.activityModel$ | async; as activity) {
  <div class="sub-header">
    <div class="sub-header-row border-top align-items-center px-1">
      <div class="row">
        @if (this.customActions$ | async; as customActions) {
          <div class="col">
            @for (action of customActions; track action) {
              <a
                [class]="action.buttonType | buttontypepipe"
                class="btn-sm btn"
                (click)="triggerStatusFlow(action.actionName, activity.id)"
                >
                {{ action.title }}
              </a>
            }
          </div>
        }
        @if (this.activityStatusFlows$ | async; as activityStatus) {
          <div
            class="col-auto state-breadcrumb-col"
            >
            <div class="state-breadcrumb">
              @for (status of activityStatus; track status) {
                <li
            [ngClass]="
              activity.status == status.status
                ? ['active-' + status.statusColor]
                : ''
            "
                  >
                  {{ status.label }}
                </li>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
